interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  const btn =
    "flex h-10 min-w-[2.5rem] items-center justify-center rounded-md border px-3 font-label text-sm transition-colors cursor-pointer";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" aria-hidden="true"></i>
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={
            page === current
              ? `${btn} border-primary-500 bg-primary-500 text-background-50`
              : `${btn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300`
          }
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className={`${btn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
      </button>
    </nav>
  );
}